import {TweenMax, TimelineMax} from 'gsap';

export class Introduction {

  public static element: HTMLElement;
  public static $element: JQuery<HTMLElement>;

  public static closed: boolean = false;

  public static introExists: boolean = true;

  public static init() {

    Introduction.$element = $('.Introduction');

    if (Introduction.$element.length) {
      Introduction.events();
    }
  }

  public static events() {

    let tl = new TimelineMax({repeat:-1});

    tl.to(Introduction.$element.find('.scroll'), 0.5, {height: '100%'});
    tl.set(Introduction.$element.find('.scroll'), {top: 'auto', bottom: '0'});
    tl.to(Introduction.$element.find('.scroll'), 0.5, {height: '0%', delay: 0.2});
    tl.set(Introduction.$element.find('.scroll'), {top: '0', bottom: 'auto'});

    var $scroll = $('html, body');

    setTimeout(function () {
      if(Introduction.introExists === true) {
        $scroll.animate({
          scrollTop: $("#Home-Scroll").offset().top
        }, 500);
        return false;
      }
    }, 10000);

    $('.Introduction').on('click', function() {
      $scroll.animate({
        scrollTop: $("#Home-Scroll").offset().top}, 500);
      return false;
    });

    $(window).on('scroll', function() {
      if($(window).scrollTop() >= $(window).height()) {
        Introduction.$element.remove();
        Introduction.introExists = false;
      }
    });

  }
}